export default class CookieService {
  constructor ({ cookieReader }) {
    this._cookieReader = cookieReader
  }

  valueOf (cookieName) {
    return this._cookieReader.get(cookieName)
  }
}
